// extracted by mini-css-extract-plugin
export default {"questions":"AhCYJ","quiz":"KNRRs","questions-list":"uQj_o","container":"ivWhN"};